module.exports = __webpack_public_path__ + "assets/img/202108-1.626b1d35.png";